const LEAK_RE = /CHAT-\d|dataset\s+CHAT|VB\s*graduaci|\bpasada\s*\d/i;
const DRAFT_MARK_RE = /AIPECES:[A-Z]|METADATOS|GATES DE HONESTIDAD/i;

export function textHasInternalLeak(text: string | null | undefined): boolean {
    return LEAK_RE.test(String(text || ''));
}

export function patchHasInternalLeak(values: Array<string | null | undefined>): boolean {
    return values.some((v) => textHasInternalLeak(v));
}

export function textHasDraftMarkers(text: string | null | undefined): boolean {
    return DRAFT_MARK_RE.test(String(text || ''));
}
